import { Chip } from "@nextui-org/react";
import { ComponentPropsWithoutRef, FC, ReactNode } from "react";

export type ZChipColorValues = "green" | "yellow" | "red"

type ChipProps = {
  children: ReactNode;
  color: ZChipColorValues;
} & ComponentPropsWithoutRef<typeof Chip>;

const COLOR_CLASSES: Record<ChipProps["color"], string> = {
  green: "bg-green-200 text-green-700",
  yellow: "bg-yellow-200 text-yellow-700",
  red: "bg-red-200 text-red-700",
};

const ZChip: FC<ChipProps> = ({ children, color, ...rest }) => {
  return (
    <Chip
      className={`rounded-full px-4 py-1 font-semibold ${COLOR_CLASSES[color] ?? "bg-gray-200 text-gray-700"}`}
      size="sm"
      {...rest}
    >
      {children}
    </Chip>
  );
};

export default ZChip;
